import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, Form, Upload, MessagePlugin } from 'tdesign-react';
import { licenseUpload } from '@/services/licenseService';
import eventBus from '@/utils/eventBus';

const { FormItem } = Form;
// const msg =
//   '您的[测试-即将过期]、[测试-非消息轨迹]版本license中集群格式已超配额，限制集群数3个，当前集群数4个，请及时升级！';

export default function LicenseAlert() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [licenseMsg, setLicenseMsg] = useState('');
  const [licenseCode, setLicenseCode] = useState('');

  useEffect(() => {
    eventBus.on('licenseMessage', handleMessage);
    return () => {
      eventBus.off('licenseMessage', handleMessage);
    };
  }, []);

  const handleMessage = (e) => {
    setVisible(true);
    setLicenseMsg(e.publicMessage);
    setLicenseCode(e.code);
  };

  const handleClose = () => {
    setVisible(false);
    if (licenseCode !== 31212) {
      navigate('/login');
    }
  };

  const handleConfirm = () => {
    form.submit();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        const formData = new FormData();
        formData.append('licenseFile', fields.licenseFile[0].raw);
        await licenseUpload(formData);
        MessagePlugin.success('操作成功');
        setVisible(false);
        window.location.reload();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  // 处理特殊字段
  const handleLicenseMsg = (data) => {
    // 匹配以 [] 结尾的部分
    const regex = /\[(.*?)\]/g;
    // 使用 replace 方法替换匹配到的部分
    let resultString = data.replace(regex, function (match, p) {
      return ` <span style="padding: 3px 6px; background-color: var(--td-brand-color-light); color: var(--td-brand-color);border-radius: var(--td-radius-default);
      border: 1px solid transparent;">${p}</span> `;
    });
    resultString = resultString.replace(/\b(\d+)\b/g, function (match, p) {
      return `<span style="font-weight: bold; color: #194dff">${p}</span>`;
    });

    return resultString;
  };

  return (
    <>
      <Dialog
        header='License校验失败'
        theme='warning'
        visible={visible}
        confirmBtn={{ loading: submitting, content: '确定' }}
        cancelBtn='取消'
        onClose={handleClose}
        onConfirm={handleConfirm}
        closeOnOverlayClick={false}
        closeOnEscKeydown={false}
        width={650}
      >
        <p
          style={{ fontSize: 16, lineHeight: 2 }}
          dangerouslySetInnerHTML={{ __html: handleLicenseMsg(licenseMsg) }}
        ></p>
        <Form style={{ width: '90%', marginTop: 30 }} form={form} onSubmit={handleSubmit}>
          <FormItem name='licenseFile' label='授权证书' rules={[{ required: true }]}>
            <Upload theme='file' autoUpload={false} />
          </FormItem>
        </Form>
      </Dialog>
    </>
  );
}
